// const API_URL = "http://localhost:5000/";

// const API_URL = "http://192.168.1.74:5000/";
// const API_URL = "https://api.gatexam.org/";
// const API_URL = "https://star-360.com/";
// const API_URL = "https://api.star-360.com/";
const API_URL = "https://talenttrackedu.com/";
// const API_URL = "/";

export default API_URL;
